// extracted by mini-css-extract-plugin
module.exports = {"boton":"Shipments_boton__ts66e","sortTotal":"Shipments_sortTotal__2APSV","SortMapShip":"Shipments_SortMapShip__371z2","PMaped":"Shipments_PMaped__2uggu"};